var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-max-height bg-white text-foreground rounded-md overflow-hidden mb-2"},[_c('trumbowyg',{staticClass:"form-control",attrs:{"config":_vm.config,"name":"content"},on:{"input":_vm.onEditorInput},model:{value:(_vm.valueText),callback:function ($$v) {_vm.valueText=$$v},expression:"valueText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }